(function ($) {
  $(document).ready(function () {

    $("input[name='updates[]']").on('input', function () {
      $("input[name='update']").trigger("click");
    });

    if ($(".hero-custom").length == 0) {
      $(".site-header, .site-header__mobile-nav").addClass("dark");
    }

    if (
      $("#shopify-section-section-guide-banner").length > 0 ||
      $(".template-cart").length > 0
    ) {
      $(".site-header, .site-header__mobile-nav").removeClass("dark");
    }

    setTimeout(() => {
      if ($("#shopify-section-161597494002d42fd6").length > 0) {
        let section_scroll_to = $("#shopify-section-161597494002d42fd6");
        let e_offset = section_scroll_to.offset();
        let e_to = e_offset.top;

        $("a[href='#scrollto']").on("click", function () {
          window.scrollTo({
            top: e_offset.top,
            behavior: "smooth",
          });
        });
      }
    }, 500);

    $(".product-form__item .radio-input").each(function () {
      if ($(this).find("input").attr("checked")) {
        $(this).addClass("checked");
      }
    });

    $(".product-form__item .radio-input").on('click', function () {
      setTimeout(function () {
        let price = $('.price__sale .price-item--sale').html();
        $('.btn_price').html(price);
      }, 100);
    });

    $(".product-form__item .radio-input input").on("click", function () {
      $(this).parent().siblings().removeClass("checked");
      $(this).parent().addClass("checked");

      let parent = $(this).closest(".product-single__meta");
      let parent_thumb = $(".product-slider-wrapper");

      if ($(this).val() == 'with Stand') {
        parent.find(".product-single__description").addClass("active");
        parent_thumb.find(".slick-dots li:nth-child(2)").click();
      } else if ($(this).val() == 'with Clips') {
        parent.find(".product-single__description").addClass("active");
        parent_thumb.find(".slick-dots li:nth-child(3)").click();
      } else {
        parent.find(".product-single__description").removeClass("active");
        parent_thumb.find(".slick-dots li:nth-child(1)").click();
      }
    });


    $(document).on("click", ".product-quantity-set", function (e) {
      let current_val = Number($(this).siblings("input").val());
      let new_val = 0;

      if ($(this).hasClass('plus')) {
        new_val = current_val + 1;
      } else if ($(this).hasClass('minus')) {
        new_val = current_val - 1;
      }

      if (new_val < 2) {
        new_val = 1;
      } else if (new_val > 5) {
        new_val = 5;
      }

      if ($('.product-form__cart-submit .btn_price').length) {
        var price = $('.price-item--sale').html().replace('$', '');
        price = parseFloat(price);
        price = price * new_val;
        price = price.toFixed(2).toString();
        $('.product-form__cart-submit .btn_price').html('$' + price);
      }


      if ($('.bandle_info').length > 0) {
        $('.bandle_info p').removeClass('active');
        $('.price__regular').removeClass('line_thrue');
        $('.price__sale').removeClass('show');
        if (new_val == 2) {
          $('.bandle_info p:eq(0)').addClass('active');
        } else if (new_val >= 3) {
          $('.bandle_info p:eq(1)').addClass('active');
        }
      }

      $(this).siblings("input").val(new_val);
      var parent = $(e.target).closest('.cart__row');
      var currentVariant = parent.attr('data-cart-item-key');
      if (typeof currentVariant !== 'undefined') {
        $(this).siblings("input").trigger("change");

        $.ajax({
          url: '/cart/change.js',
          type: 'post',
          dataType: 'json',
          data: { quantity: new_val, id: currentVariant },
          success: function (res) {
            res.items.forEach(item => {
              $(".cart-table tr").each(function () {
                if ($(this).attr("data-cart-item-key") == item.variant_id) {
                  let price = theme.Currency.formatMoney(item.final_line_price, theme.moneyFormat),
                    original_price = theme.Currency.formatMoney(item.original_line_price, theme.moneyFormat);

                  if (price != original_price) {
                    $(this).find("[data-cart-item-original-price]").html(original_price);
                    $(this).find(".order-discount").html(price);
                  } else {
                    $(this).find(".line-final-price").html(price);
                  }
                  $(this).find(".line-final-price").html(price);
                }
              });
            });

            let propose = get_propose(res);

            if (propose) {
              $(document).find(".cart-popup-extended .upgrade").removeClass("hide");
            } else {
              $(document).find(".cart-popup-extended .upgrade").addClass("hide");
            }

            let total_amount = theme.Currency.formatMoney(res.total_price, theme.moneyFormat);
            $(".cart-subtotal__price").text(total_amount);

            $("[data-cart-count]").text(res.item_count);
          },
        });
      }
    });

    $(".product-form button").on("click", function (e) {
      e.preventDefault();
      let form = $(this).closest("form");
      window.loader = $(this).find("[data-loader]");
      window.button_text = $(this).find("[data-add-to-cart-text]");
      button_text.addClass("hide");
      loader.removeClass("hide");
      const bundleId = Date.now();

      form.find('input[name="properties[bundle_id]"]').remove();
      form.append(`<input type="hidden" name="properties[bundle_id]" value="${bundleId}">`);
      let form_data = $(this).closest("form").serialize();

      (function ($) {
        function confirmUpsellProducts() {
          let upsellProducts = [];

          $("lb-upsell-product-page-addon lb-product-card").each(function () {
            if ($(this).find(".lb-spc-border-fb").length > 0) {
              let title = $(this).find(".lb-spc-details-name").text().trim();
              let qty = parseInt($(this).find(".lb-spc-details-qty-picker-q").text().trim()) || 1;
              upsellProducts.push({ title, qty });
            }
          });

          add_to_cart(form_data);

          setTimeout(async function () {
            const cart = await $.getJSON("/cart.js");

            for (const item of cart.items) {

              for (const upItem of upsellProducts) {

                if (
                  item.title === upItem.title &&
                  !Object.keys(item.properties).length
                ) {

                  await $.ajax({
                    url: "/cart/change.js",
                    type: "POST",
                    dataType: "json",
                    data: {
                      id: item.key,
                      quantity: item.quantity,
                      properties: { ID: bundleId },
                    },
                  }).catch(err => {
                    console.error("Error updating item:", err.responseText || err);
                  });
                } else {
                  console.log("Цей продукт карточки не підходить", upItem.title);
                }
              }
            }

          }, 10);
        }

        confirmUpsellProducts();
      })(jQuery);
    });


    $(".updateItemToCart_x2").on("click", function (e) {
      e.preventDefault();
      let formData = {
        items: [
          {
            id: 39808374833341,
            quantity: 2,
          },
        ],
      };

      add_to_cart(formData);
    });

    $(".updateItemToCart_x3").on("click", function (e) {
      e.preventDefault();
      let formData = {
        items: [
          {
            id: 39808374833341,
            quantity: 3,
          },
        ],
      };

      add_to_cart(formData);
    });

    $('.single_bundle button').on('click', function (e) {
      e.preventDefault();
      let id = $(this).attr('bandle-id'),
        qty = $(this).attr('bandle-qty');
      let formData = {
        items: [
          {
            id: id,
            quantity: qty,
          },
        ],
      };

      add_to_cart(formData);
    });

    $(".updateItemToCart").on("click", function (e) {
      e.preventDefault();

      let id = $(this).closest(".cart__row").attr("data-id");
      let qty = $(this).closest(".cart__row").find(".cart__qty-input").val();
      let count = 0;

      if ($('.cart-table tbody .cart__row').length > 1) {
        $('.cart-table tbody .cart__row').each(function () {
          if ($(this).find('.cart__qty-input').length > 0) {
            count = parseInt($(this).find('.cart__qty-input').val());
          }
        });
      }

      let formData = {
        items: [
          {
            id: id,
            quantity: qty,
          },
        ],
      };

      if (count > qty) {
        let new_count = count - qty;
        data = {
          updates: {
            "39808374833341": new_count,
          },
        };
        jQuery.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: data,
          dataType: 'json',
          success: function (response) {
            add_to_cart(formData);
          },
        });
      } else {
        if ($('.cart-table tbody .cart__row').length > 1) {
          $('.cart-table tbody .cart__row:last-child').remove();
        }
        $.ajax({
          type: "POST",
          url: '/cart/clear.js',
          data: '',
          dataType: 'json',
          success: function () {
            add_to_cart(formData);
          },
          error: function (XMLHttpRequest, textStatus) {
          },
        });
      }
    });

    $(".cart-popup-extended .cart__add").on("click", function (e) {
      e.preventDefault();
      let item = $(this).closest("tr");
      let form_data =
        'pr_var=' +
        item.attr("data-pr-var") +
        '&id=' +
        item.attr("data-id") +
        '&quantity=' +
        item.find('.cart__qty-input').val();

      get_cart_data_upsale(form_data);
    });

   $(function () {
      $(".discount_buttons-slider").slick({
        slidesToShow: 1,
        slideToScroll: 1,
        dots: true,
        arrows: false,
        infinite: false,
        responsive: [
          {
            breakpoint: 993,
            settings: "unslick",
          },
        ],
      });
    });

    $(document).on("click", ".product-form__cart-submit", function (e) {
      e.preventDefault();
      $("#CartCount").removeClass("hide");
    });

    $(document).on("click", ".body-overlay, .close-popup-cart", function () {
      $("body").removeClass("locked");
      $(".cart-popup-extended").removeClass("active");
      $(".body-overlay").removeClass("active");
    });

    $(".site-header__icon.site-header__cart").on("click", function (e) {
      e.preventDefault();

      if ($("body").hasClass("locked")) {
        $(".js-mobile-nav-toggle").trigger("click");
      }

      get_cart_data();

      return false;
    });

    $(document).on("click", ".cart-popup-extended .cart__remove", function (e) {
      e.preventDefault();

      var parentrow = $(e.target).closest(".cart__row");
      let current_item_key = parentrow.attr("data-cart-item-key");

      var rawProps = parentrow.find("[data-properties]").attr("data-properties");
      console.log("rawProps: зі сторінки", rawProps);
      if (!rawProps || rawProps.trim() === "") {
        rawProps = "{}";
      }

      let parsedProps;
      try {
        parsedProps = JSON.parse(rawProps);
      } catch (err) {
        console.error("Invalid JSON in data-properties:", rawProps);
        parsedProps = {};
      }

      function normalizeProps(parsed) {
        let result = {};

        if (Array.isArray(parsed)) {
          parsed.forEach(([key, value]) => {
            if (!isNaN(value)) value = Number(value);
            result[key] = value;
          });
          return result;
        }

        for (let key in parsed) {
          let value = parsed[key];
          if (!isNaN(value)) value = Number(value);
          result[key] = value;
        }

        return result;
      }

      const props = normalizeProps(parsedProps);
      const productTitle = parentrow.find(".cart__product-title").text().trim();

      console.log("NORMALIZED PROPS:", props); 

      function matchProperties(itemProps, targetProps) {
        if (!itemProps || !targetProps) return false;

        const itemKeys = Object.keys(itemProps);
        const targetKeys = Object.keys(targetProps);

        if (itemKeys.length !== targetKeys.length) return false;

        return targetKeys.every(key => itemProps[key] == targetProps[key]);
      }

      $.getJSON("/cart.js", function (cart) {
        const item = cart.items.find(i => {
          return (
            matchProperties(i.properties, props) &&
            productTitle.trim().includes(i.title.trim())
          );
        });

        console.log("props:", props);
        console.log("FOUND item:", item);

        if (!item) {
          console.error("❌ Item with these properties NOT FOUND in cart.js");
          return;
        }

        const keyToDelete = item.key;
        console.log("KEY TO DELETE:", keyToDelete);

        $.ajax({
          url: "/cart/change.js",
          type: "post",
          dataType: "json",
          data: { quantity: 0, id: keyToDelete },
          success: function () {

  if (props.bundle_id) {
  const bundleCode = props.bundle_id;

  $.getJSON("/cart.js", function(cart) {

    const toDelete = cart.items.filter(i =>
      i.properties && Number(i.properties.ID) === Number(bundleCode)
    );

    if (toDelete.length === 0) {
      get_cart_data();
      return;
    }

    let completed = 0;

    toDelete.forEach(child => {
      $.ajax({
        url: "/cart/change.js",
        type: "post",
        dataType: "json",
        data: { quantity: 0, id: child.key },
        complete: function () {
          completed++;

          if (completed === toDelete.length) {
            console.log("Видалено набір:", toDelete);
            get_cart_data();
          }
        }
      });
    });
  });
}


  get_cart_data();
  parentrow.remove();
},
          error: function (err) {
            console.error("Error removing item:", err);
          },
        });
      });
    });

    $(".product-slider-wrapper .product-slider").slick({
      slidesToShow: 1,
      slideToScroll: 1,
      dots: true,
      arrows: true,
    });

    $(".quotes-slider-wds .quotes-slider").slick({
      slidesToShow: 2,
      slideToScroll: 2,
      dots: true,
      arrows: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
      ],
    });

    $(".sps-section__slider").slick({
      slidesToShow: 1,
      slideToScroll: 1,
      dots: true,
      arrows: false,
      infinite: false,
    });

    $(document).on("click", ".js-mobile-nav-toggle", function () {
      if ($(this).hasClass("mobile-nav--open")) {
        $(".site-header").removeClass("mobile-nav-active");
        $("body").removeClass("locked");
      } else {
        $(".site-header").addClass("mobile-nav-active");
        $("body").addClass("locked");
      }
    });

    $(".site-nav--has-dropdown").hover(
      function () {
        $(this).addClass("site-nav--active-dropdown");
      },
      function () {
        $(this).removeClass("site-nav--active-dropdown");
      }
    );

    $(".accordion-item p").on("click", function () {
      let parent_acccordion = $(this).closest(".accordion-item");
      parent_acccordion
        .siblings(".accordion-item")
        .each(function () {
          $(this).find("p:eq(1)").slideUp(150);
          $(this).removeClass("active");
        });
      if (parent_acccordion.hasClass("active")) {
        parent_acccordion.find("p:eq(1)").slideUp(150);
        parent_acccordion.removeClass("active");
      } else {
        parent_acccordion.find("p:eq(1)").slideDown(150);
        parent_acccordion.addClass("active");
      }
    });

    $(document).ajaxStop(function () {
      $('.item__title').each(function () {
        $(this)
          .find('a')
          .text($(this).find('a').text().replace('- without Stand', ''));
      });
    });

    if ($('.price-item--sale').length) {
      var price = $('.price-item--sale').html();
      $('.product-form__cart-submit').append(
        ' - <span class="btn_price">' + price + '</span>'
      );
    }

    $('.qty_btns a').on('click', function (e) {
      e.preventDefault();
      $('.qty_btns a').removeClass('active');
      $(this).addClass('active');
      var price = $('.price-item--sale').html().replace('$', '');
      price = parseFloat(price);
      if ($(this).hasClass('one')) {
        $('.product-form__input--quantity').val('1').change();
      }
      if ($(this).hasClass('two')) {
        $('.product-form__input--quantity').val('2').change();
        price = price * 1.76;
      }
      if ($(this).hasClass('three')) {
        $('.product-form__input--quantity').val('3').change();
        price = price * 2.64;
      }
      price = price.toFixed(2).toString();
      $('.product-form__cart-submit .btn_price').html('$' + price);
    });
  });

  function updateItemToCart(variant_id, qty, selling_plan) {
    const groupId = `group_${Date.now()}_${Math.random().toString(36).substr(2, 5)}`;
    data = {
      id: variant_id,
      quantity: qty,
      selling_plan: selling_plan,
      properties: {
        group_id: groupId,
      },
    };
    jQuery.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function (response) {
        get_cart_data(upgrade);
      },
    });
  }

  function add_to_cart(data, upgrade = false) {
    if (data.items && Array.isArray(data.items)) {
      data = data.items[0];
    }

    data.quantity = parseInt(data.quantity);

    $.ajax({
      url: "/cart/add.js",
      type: "POST",
      data: data,
      dataType: "json",
      success: function (response) {
        get_cart_data(upgrade);
      },
      error: function (err) {
        console.error("Add to cart error:", err.responseText || err);
      },
    });
    
  }

  function get_cart_data_upsale(form_data) {
    $.ajax({
      url: '/cart.js',
      type: 'get',
      dataType: 'json',
      success: function (response) {
        response.items.forEach(item => {
          if (item.id == '39808374833341') {
            item.quantity = item.quantity - 1;

            $.ajax({
              url: '/cart/change.js',
              type: 'post',
              dataType: 'json',
              data: { quantity: item.quantity, id: item.id },
              success: function () {
                if (item.quantity == 0) {
                  let r = $(document).find(".cart-table.top tr");
                  r.each(function () {
                    if ($(this).attr("data-cart-item-key").substr(0, 14) == 39808374833341) {
                      $(this).remove();
                    }
                  });
                }
                add_to_cart(form_data);
              },
            });
          }
        });
      },
    });
  }

  function get_cart_data(upgrade = false) {
    $.ajax({
      url: '/cart.js',
      type: 'get',
      dataType: 'json',
      success: function (response) {
        show_cart_popup(response, upgrade);
        if (typeof window.loader !== 'undefined') {
          window.loader.addClass("hide");
          window.button_text.removeClass("hide");
        }

        $("[data-cart-count]").text(response.item_count);
        return response;
      },
    });

  }

  function get_propose(response) {
    var propose = false;
    var propose_not = true;
    response.items.forEach(item => {
      if (item.id == '39808374833341' && item.quantity > 0) {
        propose = true;
      }

      if (item.id == '46651855995219') {
        propose_not = false;
        propose = false;
      }
    });

    if (propose && propose_not) {
      return true;
    }
    return false;
  }

function show_cart_popup(cart, upgrade = false) {
  const table = document.querySelector(".cart-popup-extended .cart-table.top");
  const template = table.querySelector("tr.empty");

  table.querySelectorAll("tr:not(.empty)").forEach(tr => tr.remove());

  cart.items.forEach(item => {
    const row = template.cloneNode(true);
    row.classList.remove("empty");

    row.setAttribute("data-cart-item-key", item.key);
    row.setAttribute("data-cart-item-url", item.url);

    row.querySelector("[data-properties]").setAttribute(
      "data-properties",
      JSON.stringify(item.properties || {})
    );

    row.querySelector(".cart__image").src = item.image;
    row.querySelector(".cart__product-title").textContent = item.title;

    const qtyInput = row.querySelector(".cart__qty-input");
    qtyInput.value = item.quantity;

    row.querySelector(".line-final-price").textContent =
      theme.Currency.formatMoney(item.line_price, theme.moneyFormat);

    table.appendChild(row);
  });

  $(".cart-popup-extended .cart-subtotal__price").text(
    theme.Currency.formatMoney(cart.total_price, theme.moneyFormat)
  );

  if (get_propose(cart)) {
    $(".cart-popup-extended .upgrade").removeClass("hide");
  } else {
    $(".cart-popup-extended .upgrade").addClass("hide");
  }

  if (cart.items.length > 0) {
    $(".cart-popup-extended .popup-inner").removeClass("hide");
    $(".cart-popup-extended .empty-cart").addClass("hide");
  } else {
    $(".cart-popup-extended .popup-inner").addClass("hide");
    $(".cart-popup-extended .empty-cart").removeClass("hide");
  }

  $("body").addClass("locked");
  $(".cart-popup-extended").addClass("active");
  $(".body-overlay").addClass("active");
}

  window.scroll_to = 0;
  window.scroll_down = false;
  window.scroll_top = 0;

  window.onscroll = function () {
    scroll_top = $(document).scrollTop();

    if (scroll_top > scroll_to) {
      scroll_down = true;
    } else {
      scroll_down = false;
    }

    set_header_position();

    scroll_to = $(document).scrollTop();
  };

  function set_slider_animate() {
    $(".quotes-slider-wds .quotes-slide").each(function () {
      let slide_motion,
        slide_height,
        slide_height_new;

      if ($(this).hasClass("odd")) {
        slide_motion = $(this).find(".image-item.index-2 .img-container");
        slide_height = slide_motion.outerHeight();
        slide_height_new = slide_height - slide_height * 0.25;
      } else {
        slide_motion = $(this).find(".image-item.index-1 .img-container");
        slide_height = slide_motion.outerHeight();
        slide_height_new = slide_height - slide_height * 0.4;
      }

      let translate = slide_height - slide_height_new;

      slide_motion.css("height", slide_height_new + "px");
      slide_motion.find("img").css("transform", "translateY(-" + translate + "px)");

      slide_motion.attr("data-translatey", translate);
      slide_motion.attr("data-translatey-current", "-" + translate);
      slide_motion.addClass("animate");
    });
  }

  function animate_slider_wds() {
    let slider = $(".quotes-slider-wds");

    if (slider.length > 0) {
      var start_slider_pos = slider.offset().top;
      var end_slider_pos = start_slider_pos + slider.outerHeight() + window.innerHeight;
      var h = scroll_top + window.innerHeight / 1.25;

      slider.find(".quotes-slide .animate").each(function () {
        let t = parseFloat($(this).attr("data-translatey"));
        let tc = parseFloat($(this).attr("data-translatey-current"));

        if (h > start_slider_pos && h < end_slider_pos) {
          let c = slider.outerHeight() / window.innerHeight;
          let tr = 0;

          if (scroll_down) {
            tr = tc + c;
          } else {
            tr = tc - c;
          }

          if (tr <= 0 && tr > parseFloat('-' + t)) {
            $(this).find("img").css("transform", "translateY(" + tr + "px)");
            $(this).attr("data-translatey-current", tr);
          }
        }
      });
    }
  }

  function init_slider_wds() {
    setTimeout(() => {
      set_slider_animate();
    }, 300);

    var slider_options = {
      canUseTouchEvents: true,
      type: 'slide',
      slideActiveClass: 'slick-active',
      slidesToShow: 2,
      slidesToScroll: 2,
      canUseTouchEvents: false,
    };

    if ($(window).width() < 768) {
      slider_options = {
        canUseTouchEvents: true,
        type: 'slide',
        slideActiveClass: 'slick-active',
        slidesToShow: 1,
        slidesToScroll: 1,
        canUseTouchEvents: true,
      };
    }

    setTimeout(() => {
      let slider = new theme.Slideshow(
        document.getElementById("data-slider-wds"),
        slider_options
      );
    }, 500);
  }

  var header_change_pos;
  var header_change_pos_remove;
  function set_header_position() {
    if ($(document).find(".js-mobile-nav-toggle").hasClass("mobile-nav--close")) {
      return;
    }

    if ($(document).scrollTop() > 90) {
      clearTimeout(header_change_pos);

      $(".site-header, .site-header .site-header__mobile-nav").addClass("scrolling");
      if (scroll_down === false) {
        $(".scrolling").addClass("active");
        $(".scrolling").removeClass("not");
      } else {
        $(".scrolling").addClass("active");
        $(".scrolling").removeClass("not");
      }
    } else {
      clearTimeout(header_change_pos_remove);
      clearTimeout(header_change_pos);
      $(".scrolling").addClass("not");

      $(".scrolling").removeClass("active");
      $(".site-header, .site-header .site-header__mobile-nav").removeClass("scrolling");
    }
  }

  if ($(".hero_subtitles").length > 0) {
    $(".hero_subtitles").each(function (i) {
      var items = $(this).find(".item");
      if (items.length > 0) {
        hero_subtitles();
        var hero_animation = setInterval(hero_subtitles, 1000);
      }
    });
  }

  function hero_subtitles() {
    var items = $(".hero_subtitles .item");

    var current_item = $(".hero_subtitles .item.current");
    if (current_item.length > 0) {
      let i = current_item.index();

      $(current_item).removeClass('current');
      $(current_item).addClass('hiden');

      let next_i = i + 1;
      if (next_i == items.length) {
        next_i = 0;
      }
      let second_i = next_i + 1;
      if (second_i == items.length) {
        second_i = 0;
      }

      let third_i = second_i + 1;
      if (third_i == items.length) {
        third_i = 0;
      }

      let second_el = items[second_i];
      let third_el = items[third_i];

      let left_padding = 30;
      if ($(window).width() < 768) {
        left_padding = 10;
      }

      let top_padding = 10;
      if ($(window).width() < 768) {
        top_padding = 6;
      }

      $(second_el).css({
        transform: 'translate3d(' + left_padding + 'px, ' + top_padding + 'px, 0)',
        'z-index': '20',
      });
      $(third_el).css({
        transform: 'translate3d(' + left_padding * 2 + 'px, ' + top_padding * 2 + 'px, 0)',
        'z-index': '10',
      });

      $(second_el).removeClass('hiden');
      $(third_el).removeClass('hiden');

      let next_el = items[next_i];

      $(next_el).find("span").css("opacity", 1);
      $(second_el).find("span").css("opacity", 0.6);
      $(third_el).find("span").css("opacity", 0.5);

      $(next_el).css("opacity", 0.6);
      $(second_el).css("opacity", 0.4);
      $(third_el).css("opacity", 0.3);

      $(next_el).removeClass('hiden');
      $(next_el).addClass('current');
    } else {
      let el = items[0];
      $(el).addClass('current');
    }
  }
})(jQuery);


var canv = document.getElementById('canv');

if (canv && canv.getContext) {
  var ctx = canv.getContext('2d');

  var col = function (x, y, r, g, b) {
    ctx.fillStyle = "rgb(" + r + "," + g + "," + b + ")";
    ctx.fillRect(x, y, 1, 1);
  };

  var R = function (x, y, t) {
    return Math.floor(250 + 10 * Math.cos((x * x - y * y) / 300 + t));
  };

  var G = function (x, y, t) {
    return Math.floor(
      210 +
      10 *
      Math.sin(
        (x * x * Math.cos(t / 4) + y * y * Math.sin(t / 3)) / 300
      )
    );
  };

  var B = function (x, y, t) {
    return Math.floor(
      180 +
      10 *
      Math.sin(
        5 * Math.sin(t / 3) +
        ((x - 100) * (x - 100) + (y - 100) * (y - 100)) / 1100
      )
    );
  };

  var t = 0;

  var run = function () {
    for (var x = 0; x <= 35; x++) {
      for (var y = 0; y <= 35; y++) {
        col(x, y, R(x, y, t), G(x, y, t), B(x, y, t));
      }
    }
    t = t + 0.015;
    window.requestAnimationFrame(run);
  };

  run();
}
